import {Provider} from '@angular/core';

import {
  ListDocumentTypesUseCaseProvider
} from '@features/setting/presentation/providers/list-document-types/list-document-types.use-case.provider';

import {ListDocumentTypesFacade} from '@features/setting/presentation/facades/list-document-types/list-document-types.facade';

export const ListDocumentTypesFacadeProvider: Provider[] = [
  ListDocumentTypesUseCaseProvider,
  ListDocumentTypesFacade
];
